import { render } from "./ButtonCancel.vue?vue&type=template&id=dac72f48"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__